import { render, staticRenderFns } from "./free-item-peramount-product-list.vue?vue&type=template&id=d1702d0c&scoped=true&"
import script from "./free-item-peramount-product-list.vue?vue&type=script&lang=js&"
export * from "./free-item-peramount-product-list.vue?vue&type=script&lang=js&"
import style0 from "./free-item-peramount-product-list.vue?vue&type=style&index=0&id=d1702d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1702d0c",
  null
  
)

export default component.exports